import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { openDialog, hideDialog, setSaveState } from '../../actions';
import { addMaquinaCentro, removeMaquinaCentro, modifyMaquinaCentro } from '../../actions/maquina_centros_actions';

const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});



class MaquinaCentros extends React.Component {


    addCentro = (centro) => {
        this.props.setSaveState(true);
        this.props.addMaquinaCentro(centro);
    };

    modifyCentroMaquina = (centro) => {
        this.props.setSaveState(true);
        this.props.modifyMaquinaCentro(centro);
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, "message_maquina_centros", false, 'sm');

    };

    checkCentro = (centro) => {

        if (centro.fEnd !== undefined && centro.fEnd !== null && centro.fEnd !== '') {
            if (centro.fEnd < centro.fIni) {
                this.messageDialog('Fechas inválidas');
                return false;
            }
        }

        return true;
    };

    newCentro = () => {

        this.props.openDialog('EditCentroMaquina', {
            centro: {},
            centros: this.props.centros,
            maquinaId: this.props.id,
            okHandler: this.addCentro,
            checkCentro: this.checkCentro,
        }, "new_maquina_centro_dialog");

    };

    editCentro = (centro) => {

        this.props.openDialog('EditCentroMaquina', {
            centro,
            centros: this.props.centros,
            maquinaId: this.props.id,
            okHandler: this.modifyCentroMaquina,
            checkCentro: this.checkCentro
        }, "edit_maquina_centro_dialog");

    };

    removeCentro = (centro, index) => {
        this.props.setSaveState(true);
        this.props.removeMaquinaCentro(centro);
    };

    render() {

        const { classes } = this.props;

        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Centros</Typography>

                {this.props.maquinaCentros && !this.props.isLoading ?
                    <NeuriteGrid
                    id="m_c"
                        columns={[
                            { key: 'centro', name: 'Centro', editable: false, dragable: false, width: 135 },
                            { key: 'fIni', name: 'Fecha Ini', editable: false, dragable: false, type: 'date', width: 80 },
                            { key: 'fEnd', name: 'Fecha End', editable: false, dragable: false, type: 'date', width: 80 },

                        ]}
                        rows={this.props.maquinaCentros}
                        buttonEdit={this.props.id !== -1}
                        //buttonDelete={this.props.id !== -1}
                        buttonNew={this.props.id !== -1}
                        onNewRowClick={this.newCentro}
                        onEditClick={this.editCentro}
                        onDeleteClick={this.removeCentro}
                        height={200}
                    />
                    : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}
            </div>
        );
    };
};


MaquinaCentros.propTypes = {
    //state
    isLoading: PropTypes.bool.isRequired,
    maquinaCentros: PropTypes.array.isRequired,

};

const mapStateToProps = state => {
    return {
        maquinaCentros: state.maquinaCentros.maquinaCentros,
        isLoading: state.maquinaCentros.isLoading,
        centros: state.centros.centros,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        addMaquinaCentro,
        removeMaquinaCentro,
        modifyMaquinaCentro,
        setSaveState
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(MaquinaCentros));